import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ErrorStateComponent } from '@forgerock/backstage-ui-components';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: [ './error.component.scss' ],
  imports: [ ErrorStateComponent ]
})
export class ErrorComponent implements OnInit {
  code: string;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.code = this.route.snapshot.paramMap.get('code') ?? '';
  }

}
